export default __webpack_public_path__ + "static/media/dinesh-dattani.7916cb5e.png";